import { useMemo } from 'react'

import { useSearchParams } from 'react-router-dom'

import Graph from '@/compoments/Graph'
import Months from '@/compoments/Months'
import PageLoader from '@/compoments/PageLoader'
import Quater from '@/compoments/Quater'
import { useGetRevenueAnalysisQuery } from '@/services/executives/executives'
import type { DateRangeQueryParams } from '@/services/types'

const ExecutivesRevenueAnalysisPage = () => {
    const [searchParams, setSearchParams] = useSearchParams()
    const params = useMemo(
        () =>
            ({
                startDate: searchParams.get('startDate'),
                endDate: searchParams.get('endDate'),
            }) as DateRangeQueryParams,
        [searchParams],
    )
    const { data, isLoading } = useGetRevenueAnalysisQuery(params, {
        skip:
            (!params.startDate && !params.endDate) ||
            params.startDate === 'null' ||
            params.endDate === 'null',
    })
    const pageData = data?.data

    if (isLoading) return <PageLoader />

    return (
        <main className="content flex flex-col">
            <div className="px-container flex flex-col flex-auto">
                <div className="row gutters-28">
                    <Graph
                        params={params}
                        revenueGraph={pageData?.revenueGraph || []}
                    />
                    <Quater revenueQuarter={pageData?.revenueQuarter || []} />

                    <Months revenueMonth={pageData?.revenueMonth || []} />
                </div>
            </div>
        </main>
    )
}

export default ExecutivesRevenueAnalysisPage
